export const PICK = 'pick';
export const DECLINE = 'decline';



// WEBPACK FOOTER //
// ./src/constants/openQuestionStatus.js